





































































































import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { Action, Mutation } from 'vuex-class';
import { Funder } from '@/types/funder';
import moment from 'moment';
import FunderMetaDataInput from '@/components/Funder/FunderMetaDataInput.vue';

@Component({
  components: {
    FunderMetaDataInput,
  },
})
export default class FunderListTile extends Vue {
  @Prop() funder!: Funder;
  @Action('funders/getFunder') getFunder!: Function;
  @Action('funders/updateFunder') updateFunder!: Function;
  @Action('notifications/addNotification') addNotification!: Function;
  @Mutation('funders/setFunderDescription') setFunderDescription!: Function;

  showFunderDetail: boolean = false;
  tabs: number = 0;

  get createdDate(): string {
    return this.fromNow(this.funder.created_at as string);
  }

  get updatedDate(): string {
    return this.fromNow(this.funder.updated_at as string);
  }

  get imageExists(): boolean {
    return this.funder.logo !== null;
  }

  get imageUrl(): string {
    const find =
      'https://s3.eu-west-2.amazonaws.com/cdn.alternativebusinessfunding.co.uk';
    const replace =
      'https://cdn.alternativebusinessfunding.co.uk/fit-in/180x180';
    return this.funder.logo!.replace(find, replace);
  }

  fromNow(fromDate: string): string {
    moment.locale('en-gb');
    const fromMoment: moment.Moment = moment(fromDate);
    const now: moment.Moment = moment();
    return now.diff(fromMoment, 'days') > 1
      ? fromMoment.calendar()
      : fromMoment.fromNow();
  }

  editFunder(): void {
    this.showFunderDetail = !this.showFunderDetail;
    if (this.showFunderDetail) {
      this.getFunder(this.funder);
    }
  }

  productLink(published: boolean): void {
    const link = this.funder.meta
      ? this.funder.meta!.slug
      : (this.funder.id as string);
    const status = published ? 'published' : 'unpublished';
    this.$router.push(`/products/${link}/${status}`);
  }

  get funderContent(): string | null {
    return this.funder.meta!.description as string;
  }
  set funderContent(value) {
    this.setFunderDescription(value);
  }

  async saveFunder() {
    this.getFunder(this.funder);
    this.setFunderDescription(this.funderContent);
    await this.updateFunder();
    this.addNotification({
      text: 'Funder description saved',
      colour: 'green',
      top: true,
      right: true,
    });
    this.showFunderDetail = false;
  }

  @Emit('viewPage')
  viewFunderPage(): string | null {
    return this.funder.id;
  }
}
